/**
 * Functions and vars shared between axes-prerender and axes-postrender.
 */
export const YEAR_MILLISECONDS = 1000 * 60 * 60 * 24 * 365;

export function checkArticle(id, product) {
  switch(product) {
  	case 'wsj':
  	  return id.slice(-1) === 'u' || id === 'preview' ||
  	    id.toLowerCase().includes('video');
  	case 'barrons':
  	  return id.slice(-1) === 'u' || id.includes('inset');
  	case 'financialnews':
  	  return id.slice(-1) === 'u' || id.includes('inset') || id === 'preview';
  	case 'marketwatch':
  	case 'mansionglobal':  	
  	  return id.includes('inset');
  	default:
  	  return true;
  }
  
}


// WEBPACK FOOTER //
// ./src/chart/inner/axes-common.js